import { ApiError, NetworkError } from '../../data/http/AppHttpClient';

/**
 * What a failed sign-in SAYS.
 *
 * The server's messages are written for a human and are used as they are, with two
 * exceptions where the API's honesty is not the UI's job: `unauthenticated` on a login is
 * deliberately vague on the server (it must not say whether the account exists), and a
 * network failure is not an authentication problem at all.
 */
export function authErrorMessage(error: unknown): string {
  if (error instanceof NetworkError) {
    return 'The server could not be reached. Check the connection and try again.';
  }
  if (error instanceof ApiError) {
    switch (error.code) {
      case 'unauthenticated':
        /**
         * IT NAMES THE PAIR, NOT THE PASSWORD (copy deck R8: what to do next, no blame, no
         * "we"). `spec/screens/login.md` section 2 item 7 writes this sentence as "That
         * password does not match. Try again or reset it.", which says the ADDRESS was
         * right - and this instance must not tell a stranger which addresses have accounts:
         * the server answers the same refusal for a wrong password, an unknown address and a
         * deactivated account (`packages/server/src/auth/service.ts:497`). So both halves
         * stay and the next step is added (ledger E-W4-49). The first clause is also what
         * `packages/e2e/specs/admin.spec.ts:181` and `:216` match on, so the sentence GROWS
         * rather than changes.
         */
        return 'That email and password do not match an account. Try again or reset the password.';
      case 'rate_limited':
        return 'Too many attempts. Wait a minute and try again.';
      default:
        return error.message;
    }
  }
  return error instanceof Error ? error.message : 'Unable to sign in. Try again.';
}
